import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import GradientTextItem from '../../../molecules/shared/gradientTextItem/GradientTextItem';

const CounterSection = ({ section }) => {
  const { processItems } = section.componentData;

  return (
    <div className="flex w-full flex-col flex-1 gap-10 px-16 lg:mx-auto my-5 max-w-5xl -mt-14 md:-mt-20">
      <div className="flex flex-col md:flex-row flex-1 justify-between py-4 gap-5 z-10">
        <div className="flex flex-col md:flex-row w-full min-h-60 h-auto bg-white shadow-xl rounded-[40px] py-6 px-6 lg:px-20 justify-between items-center max-md:gap-8">
          {processItems.map(({ number, text }, index) => (
            <React.Fragment key={index}>
              {(index === 1 || index === 2) && (
                <div className="select-none rotate-90 md:rotate-0 flex flex-row items-center justify-center h-full">
                  <Typography
                    as="span"
                    className={'font-medium tracking-widest'}
                  >
                    ------
                  </Typography>
                  <div className="w-3 h-3 rounded-full bg-customGray-900"></div>
                </div>
              )}
              <GradientTextItem text={number} description={text} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CounterSection;
